/**
 * Microsoft Clarity session replay / heatmaps.
 * Loaded post-consent via ClarityLoader — not in static index.html.
 */

export const CLARITY_PROJECT_ID = 'x44rka0l5l';

const IS_PROD =
  typeof import.meta !== 'undefined' &&
  (import.meta.env?.VITE_APP_ENV === 'production' || import.meta.env?.PROD === true);

let clarityInitStarted = false;

/** Inject clarity.ms tag after analytics cookie consent. */
export function initClarity(): void {
  if (!IS_PROD || clarityInitStarted || typeof window === 'undefined') return;
  clarityInitStarted = true;

  if (typeof window.clarity === 'function') return;

  (function (c, l, a, r, i, t, y) {
    c[a] =
      c[a] ||
      function () {
        (c[a].q = c[a].q || []).push(arguments);
      };
    t = l.createElement(r);
    t.async = 1;
    t.src = 'https://www.clarity.ms/tag/' + i;
    y = l.getElementsByTagName(r)[0];
    y.parentNode.insertBefore(t, y);
  })(window, document, 'clarity', 'script', CLARITY_PROJECT_ID);
}
